import { Chakra } from "@airhelp/react-ui-components";
import { useTranslations } from "contexts/LocalizationContext";
import Card from "./Card";
import { BEST_AIRLINES_BY_REGION } from "./consts";
import ScoreTag from "../ScoreTag";

const { Flex, Heading, Text } = Chakra;

const BestAirlinesByRegion = () => {
  const translations = useTranslations();

  return (
    <Card>
      <Heading variant="h3" as="h3" mb={5}>
        {translations("best_arilines_by_region")}
      </Heading>

      {BEST_AIRLINES_BY_REGION.map((airline) => {
        const { airline: name, score, region } = airline;
        return (
          <Flex
            key={region}
            justifyContent="space-between"
            alignItems="center"
            fontSize="sm"
            borderBottom="1px"
            borderColor="greyscale.400"
            py={4}
            position="relative"
            _last={{ borderBottom: "none", pb: 0 }}
          >
            <Flex>
              <Text fontSize="md" width={{ base: "150px", md: "250px", lg: "200px" }}>
                {translations(region)}
              </Text>
              <Text fontSize="md">{name}</Text>
            </Flex>
            <ScoreTag index={0} score={score} />
          </Flex>
        );
      })}
    </Card>
  );
};
export default BestAirlinesByRegion;
